import { observer } from "mobx-react";
import { Tabs, Empty } from "antd";
import MediaQuery from "react-responsive";
import { View } from "./View";
import { viewsStore } from "../Stores/ViewsStore";
import { ViewsSidebar } from "../Components/ViewsSidebar";
import { viewsFoldersStore } from "../Stores/ViewsFoldersStore";
import { getUrlParams } from "utils/getUrlParams";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

type Queries = "viewId" | "fileId";
type Params = { [key in Queries]?: string };

export const ViewsOverview = observer(() => {
  const [activeKey, setActiveKey] = useState("");
  const location = useLocation();

  const handleTabChange = (viewIdAsTabKey: string) => {
    if (viewIdAsTabKey !== activeKey) {
      setActiveKey(viewIdAsTabKey);
      viewsStore.setViewId(+viewIdAsTabKey);
      viewsFoldersStore.fetch();
    }
  };

  useEffect(() => {
    (async () => {
      try {
        await viewsStore.fetch();
        if (viewsStore.data.length) {
          if (location.search) {
            const params: Params = getUrlParams(location.search);
            if (params.viewId && params.fileId) {
              viewsStore.navigateToFileId = +params.fileId;
              handleTabChange(params.viewId);
            }
          } else {
            handleTabChange(viewsStore.data[0].id.toString());
          }
        }
      } catch (error) {
        throw error;
      }
    })();
  }, [location.search]);

  if (!viewsStore.data.length) {
    return <Empty />;
  }

  return (
    <MediaQuery maxWidth={767}>
      {() => (
        <div className="documents-wrapper">
          <ViewsSidebar onFolderSelect={null} />
          <div className="documents-main" style={{ width: "100%" }}>
            <Tabs
              activeKey={activeKey}
              onChange={handleTabChange}
              className="views-module-tabs"
              destroyOnHidden
              items={viewsStore.data.map((page) => {
                // when many views loaded it causes setting latest view id which is not the currently displayed.
                // So only one View page should be rendered at once
                return {
                  key: page.id.toString(),
                  label: page.name,
                  children: <View view={page} />,
                };
              })}
            />
          </div>
        </div>
      )}
    </MediaQuery>
  );
});
